module.exports = __webpack_public_path__ + "static/media/mouse.a30514d6.svg";